import React, { useState } from "react";

const InstitutionalStore = () => {
  const [email, setEmail] = useState("");

  return (
    <div className="elite-portal">
      {/* 1. Global Navigation: Minimalist MNC Style */}
      <nav className="elite-nav">
        <div className="nav-container">
          <div className="nav-logo">AADHAV<span>.</span></div>
          <div className="nav-links">
            <a href="#curriculum">Curriculum</a>
            <a href="#stationery">Stationery</a>
            <a href="#sports">Sports Gear</a>
          </div>
          <button className="nav-cta">Contact Sales</button>
        </div>
      </nav>

      {/* 2. Hero Section: High Contrast Display */}
      <section className="elite-hero">
        <div className="elite-container">
          <div className="hero-status">
            <span className="status-dot"></span> 
            April 2026 Collection
          </div>
          <h1 className="hero-title">
            Equipping the next <br />
            <span className="text-gradient">generation of icons.</span>
          </h1>
          <p className="hero-subtitle">
            A specialized institutional store for Schools, Colleges, and Academies. 
            Professional-grade curriculum and equipment, engineered for growth.
          </p>
          
          <div className="hero-form">
            <input 
              type="email" 
              placeholder="Enter your institutional email" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button>Get the Catalog</button>
          </div>
        </div>
      </section>

      {/* 3. The Bento Showcase: Adaptive Grid */}
      <section className="elite-container bento-grid">
        
        {/* Box 1: Professional Books */}
        <div className="bento-card bento-main">
          <div className="card-info">
            <label>Education</label>
            <h2>Academic Curriculum</h2>
            <p>From skill-based workbooks to comprehensive sports theory manuals. Designed for schools and coaching centers.</p>
          </div>
          <div className="card-visual-books">
            <div className="book-stack">
              <div className="book b1">LEVEL 1</div>
              <div className="book b2">LEVEL 2</div>
              <div className="book b3">LEVEL 3</div>
            </div>
          </div>
        </div>

        {/* Box 2: Custom Stationery */}
        <div className="bento-card bento-sub">
          <div className="card-info">
            <label>Branding</label>
            <h2>Custom Stationery</h2>
            <p>Personalized diaries and logs with your institution's logo.</p>
          </div>
          <div className="card-visual-icon">📓</div>
        </div>

        {/* Box 3: Multi-Sport Gear */}
        <div className="bento-card bento-sub accent">
          <div className="card-info text-white">
            <label className="text-blue-400">Athletics</label>
            <h2 className="text-white">Professional Gear</h2>
            <p className="text-slate-400">High-performance kits for Cricket, Football, and Indoor sports.</p>
          </div>
          <div className="card-visual-icon">⚽</div>
        </div>

        {/* Box 4: Logistics (Wide) */}
        <div className="bento-card bento-wide">
          <div className="wide-flex">
            <div>
              <label>Distribution</label>
              <h2>Seamless Bulk Logistics</h2>
              <p>Pan-India delivery for large institutional orders, ensuring your materials reach every student on time.</p>
            </div>
            <div className="wide-visual">📦</div>
          </div>
        </div>
      </section>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;800&display=swap');

        :root {
          --bg: #ffffff;
          --primary: #0071e3;
          --text: #1d1d1f;
          --sub: #6e6e73;
          --card: #f5f5f7;
          --nav-h: 64px;
        }

        .elite-portal {
          background: var(--bg);
          font-family: 'Inter', -apple-system, sans-serif;
          color: var(--text);
          margin: 0; padding-top: var(--nav-h);
          -webkit-font-smoothing: antialiased;
        }

        .elite-container { max-width: 1140px; margin: 0 auto; padding: 0 40px; }

        /* NAV */
        .elite-nav {
          position: fixed; top: 0; width: 100%; height: var(--nav-h);
          background: rgba(255,255,255,0.8); backdrop-filter: blur(20px);
          z-index: 100; border-bottom: 1px solid #f2f2f2;
        }
        .nav-container { 
          max-width: 1140px; margin: 0 auto; padding: 0 40px;
          display: flex; align-items: center; justify-content: space-between; height: 100%;
        }
        .nav-logo { font-weight: 800; font-size: 20px; letter-spacing: -1px; }
        .nav-logo span { color: var(--primary); }
        .nav-links { display: flex; gap: 32px; font-size: 14px; font-weight: 500; color: var(--sub); }
        .nav-links a:hover { color: var(--text); }
        .nav-cta {
          background: var(--text); color: white; border: none; padding: 8px 16px;
          border-radius: 99px; font-weight: 600; font-size: 13px; cursor: pointer;
        }

        /* HERO */
        .elite-hero { padding: 100px 0 100px; text-align: center; }
        .hero-status { 
          display: inline-flex; align-items: center; gap: 8px; font-size: 12px;
          font-weight: 600; color: var(--primary); background: #f0f7ff;
          padding: 6px 14px; border-radius: 100px; margin-bottom: 24px;
        }
        .status-dot { width: 6px; height: 6px; background: var(--primary); border-radius: 50%; }
        .hero-title { 
          font-size: 72px; font-weight: 800; letter-spacing: -3px; line-height: 1.05; margin: 0 0 24px;
        }
        .text-gradient { color: var(--sub); }
        .hero-subtitle { 
          font-size: 22px; color: var(--sub); max-width: 700px; margin: 0 auto 48px;
          line-height: 1.4; letter-spacing: -0.5px;
        }

        .hero-form {
          display: flex; max-width: 500px; margin: 0 auto; gap: 10px;
          background: #fbfbfd; padding: 8px; border-radius: 16px; border: 1px solid #eaeaec;
        }
        .hero-form input { 
          flex: 1; border: none; background: transparent; padding: 0 16px; 
          font-size: 16px; outline: none; font-weight: 500;
        }
        .hero-form button {
          background: var(--primary); color: white; border: none; padding: 12px 24px;
          border-radius: 12px; font-weight: 600; cursor: pointer;
        }

        /* BENTO GRID */
        .bento-grid { 
          display: grid; grid-template-columns: repeat(3, 1fr); 
          grid-template-rows: 400px 300px; gap: 24px; margin-bottom: 100px;
        }
        .bento-card { 
          background: var(--card); border-radius: 28px; padding: 40px;
          display: flex; flex-direction: column; justify-content: space-between;
          transition: transform 0.5s cubic-bezier(0.2, 0, 0, 1); border: 1px solid transparent;
        }
        .bento-card:hover { transform: scale(1.02); border: 1px solid #d2d2d7; }
        .bento-main { grid-column: span 2; background: #fafafa; }
        .bento-sub.accent { background: #1d1d1f; }
        .bento-wide { grid-column: span 3; }
        .wide-flex { display: flex; align-items: center; justify-content: space-between; width: 100%; }

        .card-info label { font-size: 11px; font-weight: 800; text-transform: uppercase; color: var(--primary); letter-spacing: 1px; }
        .card-info h2 { font-size: 28px; font-weight: 700; margin: 12px 0; letter-spacing: -1px; }
        .card-info p { font-size: 16px; color: var(--sub); line-height: 1.5; margin: 0; }

        .card-visual-icon { font-size: 80px; align-self: flex-end; }
        .wide-visual { font-size: 120px; }

        /* MOCKUP VISUALS */
        .card-visual-books { position: relative; height: 150px; }
        .book-stack { position: absolute; bottom: 0; right: 0; display: flex; gap: 10px; }
        .book { 
          width: 80px; height: 110px; background: var(--primary); color: white;
          font-size: 10px; font-weight: 800; display: flex; align-items: flex-end;
          padding: 10px; border-radius: 4px; box-shadow: 10px 10px 20px rgba(0,0,0,0.1);
        }
        .b2 { transform: translateY(-20px); background: #2997ff; }
        .b3 { transform: translateY(-40px); background: #60a5fa; }

        .text-white { color: white !important; }
        .text-slate-400 { color: #94a3b8 !important; }

        @media (max-width: 900px) {
          .hero-title { font-size: 48px; }
          .bento-grid { grid-template-columns: 1fr; grid-template-rows: auto; }
          .bento-main, .bento-wide { grid-column: span 1; }
        }
      `}</style>
    </div>
  );
};

export default InstitutionalStore;